export default __webpack_public_path__ + "static/media/kokoro-6.a94a8294.png";